import CustomTooltip from "shared/components/CustomTooltip";
import { IconDispatcher } from "shared/Icons";
import styled, { css } from "styled-components/macro";
import { getEmotionLevelData } from "utils/helpers";

interface SmileyReactiveComponentProps {
	emotionLevel: number;
	isSelected: boolean;
	isDisabled?: boolean;
}

export const SmileyReactiveComponent: React.FC<SmileyReactiveComponentProps> = ({ emotionLevel, isSelected, isDisabled = false }) => {
	const { smiley, smileyColor, description } = getEmotionLevelData({ level: emotionLevel });
	return (
		<CustomTooltip text={description} placement="bottom">
			<Container disabled={isDisabled}>
				<WhiteBackground>
					<Icon color={smileyColor} selected={isSelected}>
						{IconDispatcher(smiley)}
					</Icon>
				</WhiteBackground>
			</Container>
		</CustomTooltip>
	);
};

const Container = styled.div<{ disabled: boolean }>`
	width: 30px;
	height: 30px;
	flex-shrink: 0;
	cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
	display: flex;
	align-items: center;
	justify-content: center;
	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;
		`};
`;

const WhiteBackground = styled.div`
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Icon = styled.div<{ selected: boolean; color: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		width: 24px;
		height: 24px;
		color: #bfbfbf;
	}

	:hover {
		svg {
			width: 26px;
			height: 26px;
			color: ${({ color }) => color};
		}
	}

	${({ selected }) =>
		selected &&
		css`
			svg {
				width: 28px;
				height: 28px;
				color: ${({ color }) => color};
			}
		`}
`;
